export default "__VITE_ASSET__BPDDRa57__"